import React from 'react'

interface PlayButton {
  className?: string
}

export const PlayButton: React.FC<PlayButton> = () => (
  <div className="tc-mv-blur-4 tc-play-button rounded-[8px] overflow-hidden">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="68"
      height="46"
      viewBox="0 0 68 46"
      fill="none"
    >
      <path
        d="M44.6667 22.5L27.4167 32.4593L27.4167 12.5407L44.6667 22.5Z"
        fill="white"
      />
    </svg>
  </div>
)
